intSize